import { apiService } from '../api'
import {replacePathParams} from "@/helpers/urlHelpers";

const ENDPOINTS = {
  CASINO_CATEGORIES: '/casino-category',
  CASINO_CATEGORIES_CREATE: '/casino-category/:websiteId',
}

class CasinoCategoriesService {
  async create(data, websiteId) {
    return apiService.post(replacePathParams(ENDPOINTS.CASINO_CATEGORIES_CREATE, {websiteId}), data)
  }

  async update(id, data) {
    return apiService.put(`${ ENDPOINTS.CASINO_CATEGORIES }/${ id }`, data)
  }

  async delete(id) {
    return apiService.delete(`${ ENDPOINTS.CASINO_CATEGORIES }/${ id }`);
  }

  async getAll() {
    return apiService.get(ENDPOINTS.CASINO_CATEGORIES);
  }

  prepareCasinoCategoriesDataFromResponse(items) {
    const casinoCategories = [];

    items.forEach(casinoCategory => {
      casinoCategories.push({
        page: casinoCategory,
        rowData: {
          name: casinoCategory.name,
          id: casinoCategory.casinoCategoryId,
          websiteId: casinoCategory.websiteId,
          active: casinoCategory.active,
          hidden: casinoCategory.hidden,
          archived: casinoCategory.archived,
          games: casinoCategory.numberOfGames,
        }
      });
    });

    return casinoCategories;
  }
}

export const casinoCategoriesService = new CasinoCategoriesService()
